import Highcharts from 'highcharts'
import _ from 'lodash'

const xyDatas = (datas, key) => {
  const xy = []
  for (let i = 0; i < datas.length; i++) {
    const val = datas[i][key]
    if (val) {
      let val2 = val
      switch (key) {
        case 'keepRate':
          val2 = Number(val.replace('%', ''))
          break
        case 'avgDuration':
          val2 = Number(val / 1000)
          break
      }
      xy.push(val2)
    } else {
      xy.push(0)
    }
  }
  return xy
}

const onceData = (list, {
  key,
  name
}) => {
  const data = []
  for (let i = 0; i < list.length; i++) {
    data.push(list[i][key])
  }
  return {
    name,
    data
  }
}

const getMap2Series = (list) => {
  const a1 = onceData(list, { key: 'successPass', name: '通过' })
  const a2 = onceData(list, { key: 'failedPass', name: '不通过' })
  const a3 = onceData(list, { key: 'termination', name: '终止' })
  return [a1, a2, a3]
}

const getSeries = ({
  procAnalysisHisChangeList,
  startDateGroupList,
  targetType
}) => {
  const series = []
  for (let i = 0; i < procAnalysisHisChangeList.length; i++) {
    const {
      procName,
      procAnalysisList
    } = procAnalysisHisChangeList[i]
    const data2 = []
    for (let j = 0; j < startDateGroupList.length; j++) {
      const a = startDateGroupList[j]

      const i2 = _.findIndex(procAnalysisList, { startDateGroup: a })

      if (i2 >= 0) {
        data2.push(procAnalysisList[i2][targetType])
      } else {
        data2.push(0)
      }
    }
    series.push({
      name: procName,
      data: data2
    })
  }

  return series
}

const getYName = (targets, targetType) => {
  if (targetType === 'all3') {
    targetType = 'allProc'
  }
  const i = _.findIndex(targets, { key: targetType })

  let str1 = targets[i].name
  switch (targetType) {
    case 'keepRate':
      str1 += '(百分比%)'
      break
    case 'keepRateDouble':
      str1 += '(百分比%)'
      break
    case 'avgDuration':
      str1 += '(秒s)'
      break
    default:
      str1 += '(整数n)'
  }
  return str1
}

const getProcs = (datas) => {
  return _.map(datas, (item) => {
    const {
      procKey,
      procName
    } = item
    return {
      key: procKey,
      name: procName
    }
  })
}

const setMap = (options) => {
  const {
    id,
    xDatas,
    yDatas,
    yName,
    title
  } = options
  Highcharts.chart(id, {
    credits: {
      enabled: false
    },
    chart: {
      type: 'column'
    },
    title: {
      text: title
    },
    xAxis: {
      categories: xDatas,
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: yName
      }
    },
    tooltip: {
      // head + 每个 point + footer 拼接成完整的 table
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
'<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    plotOptions: {
      column: {
        borderWidth: 0
      }
    },
    series: [{
      name: '次数',
      data: yDatas,
      showInLegend: false,
      colorByPoint: true
    }]
  })
}

const setMap2 = (options) => {
  const {
    id,
    xDatas,
    yName,
    series
  } = options
  Highcharts.chart(id, {
    chart: {
      type: 'column'
    },
    title: {
      text: '流程指标统计'
    },
    xAxis: {
      categories: xDatas
    },
    yAxis: {
      min: 0,
      title: {
        text: yName
      },
      stackLabels: { // 堆叠数据标签
        enabled: true,
        style: {
          fontWeight: 'bold',
          color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
        }
      }
    },
    legend: {
      align: 'right',
      x: -30,
      verticalAlign: 'top',
      y: 25,
      floating: true,
      backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
      borderColor: '#CCC',
      borderWidth: 1,
      shadow: false
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.x + '</b><br/>' +
                this.series.name + ': ' + this.y + '<br/>' +
                '总量: ' + this.point.stackTotal
      }
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white',
          style: {
            // 如果不需要数据标签阴影，可以将 textOutline 设置为 'none'
            textOutline: '1px 1px black'
          }
        }
      }
    },
    series
  })
}

const setMapHistory = (options) => {
  const {
    id,
    xDatas,
    yName,
    series
  } = options
  Highcharts.chart(id, {
    credits: {
      enabled: false
    },
    title: {
      text: '流程历史统计'
    },
    xAxis: {
      categories: xDatas
    },
    yAxis: {
      title: {
        text: yName
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle'
    },
    series,
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  })
}

export {
  xyDatas,
  setMap,
  setMap2,
  setMapHistory,
  getSeries,
  getYName,
  getMap2Series,
  getProcs
}
